// @flow

import React from 'react';
import classNames from 'classnames';

import type {Node, StatelessFunctionalComponent as FC} from 'react';

type TBodyProps = {|
    children: Node,
    mix?: string,
|};

export const TBody: FC<TBodyProps> = ({mix = '', children}: TBodyProps) => (
    <div className={classNames('data-table__tbody', {[(mix: string)]: mix})}>
        {children}
    </div>
);
